import { ANALYST, FINANCIAL_ENTITIES } from './selectOptions';

export const HIGH_LEVEL_FILTERS = {
  FILTER_TYPES: [{ label: 'Nombre del cliente', value: 'client_name' }],
  ANALYST,
  FINANCIAL_ENTITIES,
};
